import {FC, ReactNode, useState} from 'react';
import {
    QueryClient,
    QueryClientConfig,
    QueryClientProvider,
} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

export type ReactQuerySettings = {
    children?: ReactNode;
    config?: QueryClientConfig;
    showDevTools?: boolean;
};

const ReactQuery: FC<ReactQuerySettings> = ({
    children,
    config,
    showDevTools,
}) => {
    const [queryClient] = useState(() => new QueryClient(config));

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {showDevTools && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    );
};

export default ReactQuery;
